/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes, useInputHelper } from 'framework/form';
import { EXPENSE_TYPES, EXPENSE_SUBTYPES, SUBTYPE_FIELD_LABELS, EXPENSE_TAX_COUNTRIES } from 'domain/shared/expense';

const ExpenseTaxSubTypeDropdown = ({
  officeSource,
  source,
  ...props
}: DefaultInputPropTypes<string> & { officeSource: string }) => {
  const { getRawOnChangeCallback } = useInputHelper({ source });
  const rawOnChangeCallback = getRawOnChangeCallback();
  const label = SUBTYPE_FIELD_LABELS.TAX;

  const onChange = (values: Dictionary<any>) => {
    const newValue = values[source];

    if (rawOnChangeCallback) {
      rawOnChangeCallback({
        [source]: newValue,
        [officeSource]: newValue ? EXPENSE_TAX_COUNTRIES[newValue] : null,
      });
    }
  };

  return (
    <EnumDropdown
      options={EXPENSE_SUBTYPES[EXPENSE_TYPES.TAX] || {}}
      {...props}
      source={source}
      label={label}
      placeholder={`Select ${label}`}
      onChangeCallback={onChange}
    />
  );
};

export default ExpenseTaxSubTypeDropdown;
